// src/utils/blogLoader.js

// 1. Impordime kõik failid "raw" tekstina
const modules = import.meta.glob('../content/blog/*.md', { 
  query: '?raw', 
  import: 'default', 
  eager: true 
});

export const getAllPosts = () => {
  return Object.entries(modules).map(([path, rawContent]) => {
    
    // 2. Lihtne parser: Eraldame päise (--- vahel) ja sisu
    const frontmatterRegex = /---\s*[\r\n]+([\s\S]*?)[\r\n]+---([\s\S]*)/;
    const match = frontmatterRegex.exec(rawContent);
    
    const metadata = {};
    let content = rawContent; // Vaikimisi terve tekst, kui päist pole

    if (match) {
      // Parsime YAML-i rida-realt
      const frontmatterLines = match[1].split('\n');
      content = match[2].trim(); // See on artikli sisu (Markdown)

      frontmatterLines.forEach(line => {
        const [key, ...valueParts] = line.split(':');
        
        if (key && valueParts.length) {
          let value = valueParts.join(':').trim();
          
          // Eemaldame jutumärgid ("Tiitel" -> Tiitel)
          value = value.replace(/^['"](.*)['"]$/, '$1');

          // Parsime massiive: tags: ["DevOps", "Cloud"]
          if (value.startsWith('[') && value.endsWith(']')) {
             const arrayContent = value.slice(1, -1);
             metadata[key.trim()] = arrayContent.split(',').map(s => s.trim().replace(/^['"](.*)['"]$/, '$1'));
          } else {
             metadata[key.trim()] = value;
          }
        }
      });
    }

    // 3. Slug: respect frontmatter `slug` field if present, otherwise derive from filename
    const slug = metadata.slug || path.split('/').pop().replace(/\.md$/, '');

    const wordCount = content.replace(/[#*`[\]()\-!>]/g, '').split(/\s+/).filter(w => w.length > 0).length;
    const readingTime = Math.max(1, Math.ceil(wordCount / 200));

    // Auto-derive thumbnail from image path (adds thumb- prefix) unless explicitly set
    const derivedThumbnail = metadata.thumbnail
      || (metadata.image && metadata.image.includes('/images/blog/')
        ? metadata.image.replace('/images/blog/', '/images/blog/thumb-')
        : null);

    return {
      slug,
      ...metadata,
      thumbnail: derivedThumbnail,
      lang: metadata.lang || 'en', // posts without a `lang` field are English
      content,
      readingTime,
      // Sort by last-updated when present, so refreshing an evergreen post
      // (e.g. the "Magento latest version" page) re-surfaces it to the top.
      dateObj: new Date(metadata.updated || metadata.date)
    };
  })
  // 4. Sort by date descending; break ties alphabetically by slug for stability
  .sort((a, b) => {
    const dateDiff = b.dateObj - a.dateObj;
    if (dateDiff !== 0) return dateDiff;
    return a.slug.localeCompare(b.slug);
  });
};

export const getPostBySlug = (slug) => {
  const posts = getAllPosts();
  return posts.find((post) => post.slug === slug);
};
